
    /* eslint-disable */

    import CountryConditionItemMixin from '@ve/components/countryConditions/common/components/CountryConditionItem';

    import {Component} from 'vue-property-decorator';

    @Component({
        name: 'CountryConditionItem',
    })
    export default class CountryConditionItem extends CountryConditionItemMixin {
        showDescription = false;

        toggleDescription(): void {
            if (!this.isLink) {
                this.showDescription = !this.showDescription;
            }
        }
    }
